import React from 'react';
import { useTranslation } from 'react-i18next';
import { Eye, X } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';

const ImpersonationBanner = () => {
  const { t } = useTranslation();
  const { isImpersonating, user, stopImpersonation } = useAuth();

  if (!isImpersonating) return null;

  const displayName = user ? `${user.firstName || ''} ${user.lastName || ''}`.trim() || user.email : '';

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      zIndex: 9999,
      background: 'linear-gradient(90deg, #f59e0b, #d97706)',
      color: '#fff',
      padding: '6px 16px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: 10,
      fontSize: 13,
      fontWeight: 600,
      boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
    }}>
      <Eye size={16} />
      <span>
        {t('impersonation.viewingAs')} <strong>{displayName}</strong> ({user?.role})
        {' — '}{t('impersonation.readOnly')}
      </span>
      <button
        onClick={stopImpersonation}
        style={{
          marginLeft: 12,
          background: 'rgba(255,255,255,0.2)',
          border: '1px solid rgba(255,255,255,0.4)',
          color: '#fff',
          borderRadius: 4,
          padding: '2px 10px',
          cursor: 'pointer',
          fontSize: 12,
          fontWeight: 600,
          display: 'flex',
          alignItems: 'center',
          gap: 4,
        }}
      >
        <X size={13} />
        {t('impersonation.exit')}
      </button>
    </div>
  );
};

export default ImpersonationBanner;
